import module from './module.js'

import './components/controller.js'
import './components/descargar/component.js'
import './components/lista/controller.js'
import './components/lista/grupo/controller.js'
import './routes/nominas-cfdi.js'
import './services/NominasCfdiEmpresa.js'
import './services/NominasCfdiEmpresaNomina.js'
import './services/NominasCfdiEmpresas.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/cfdi/index.js